import {Text, Tooltip} from '@primer/react'
import {AlertIcon} from '@primer/octicons-react'
import {TimelineRow} from './row/TimelineRow'

export function FallbackEvent(): JSX.Element {
  return (
    <TimelineRow
      showActorName={false}
      showAgoTimestamp={false}
      highlighted={false}
      actor={null}
      createdAt={''}
      deepLinkUrl={''}
      leadingIcon={AlertIcon}
    >
      <TimelineRow.Main>
        <Tooltip aria-label="Check your browser's console for more details" direction="ne">
          <Text>Event unavailable</Text>
        </Tooltip>
      </TimelineRow.Main>
    </TimelineRow>
  )
}

try{ FallbackEvent.displayName ||= 'FallbackEvent' } catch {}